export default __webpack_public_path__ + "static/media/Quote.efdbc3c5.svg";